import type * as React from "react";
import { memo, useRef } from "react";
import { useEffect } from "react";

interface RenderServerSideContentProps {
  content: Element | null;
  className?: string;
}

const RenderServerSideContent: React.FC<RenderServerSideContentProps> = ({ className, content }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container && content) {
      container.appendChild(content);
      return () => {
        container.removeChild(content);
      };
    }
  }, [content]);

  return <div className={className} ref={containerRef} />;
};

export default memo(RenderServerSideContent);
